"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MODAL_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  BIG: 'big'
};
var _default = MODAL_SIZE;
exports["default"] = _default;